import { IAppState } from "../models/IAppState";
import { IControlsOptionsHelper } from "../models/IControlsOptionsHelper";
import { ALL_USERS_ROLE } from "./constants";

export const GetControlOptions = (opts: any, defaultTitle: string, state: IAppState): IControlsOptionsHelper => {
    let isVisible: boolean = true;
    let isEnabled: boolean = false;
    let title = defaultTitle;
    let personaExists: boolean = false;

    if (opts) {
        title = opts.Caption;

        // Super Administrators bypass role checks
        if (state.isAdmin || opts.Roles?.includes(ALL_USERS_ROLE)) {
            isEnabled = true;
        }
        // Check user personas and Users array (non-admin path)
        else {
            const roles = opts.Roles ?? [];

            // If no personas are selected (empty/null Roles) and ControlBehavior is 'Visible',
            // hide the control from non-admins per Non-Selected Persona setting
            if (roles.length === 0 && opts.ControlBehavior === 'Visible') {
                isVisible = false;
            }

            roles.forEach((r: any) => {
                if (state.userPersonas.includes(r)) {
                    personaExists = true;
                    isEnabled = true;
                    isVisible = true;
                }
                else{
                    if (!personaExists) {
                        if(opts.ControlBehavior === 'Visible')
                            isVisible = false;
                        if(opts.ControlBehavior === 'Enabled')
                            isVisible = true;
                    }
                }
            })

            if (state.userId && opts.Users?.includes(state.userId)) {
                isEnabled = true;
                isVisible = true;
            }
        }

        //one last check for master rules
        //and check for isEnabled based on above
        if (!opts.Enabled)
            isEnabled = false;
    }

    return {
        IsEnabled: isEnabled,
        IsVisible: isVisible,
        Title: title
    } as IControlsOptionsHelper;
}